import axios from 'axios';

export const getAllApiResults = (url, results, token, resolve, reject) => {
  axios
    .get(url, { headers: { Authorization: `Bearer ${token}` } })
    .then(response => {
      const retrivedLocations = results.concat(response.data.data);
      if (response.data.paging && response.data.paging.next) {
        getAllApiResults(
          response.data.paging.next,
          retrivedLocations,
          token,
          resolve,
          reject
        );
      } else {
        resolve(retrivedLocations);
      }
    })
    .catch(error => {
      reject(error);
    });
};
